"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import { GlobalStyles } from "./GlobalStyles";
import { Navbar } from "./Navbar";
import { ContactFormContactUsPage } from "./ContactFormContactUsPage";
import { HeroSubCardComponentContainer } from "./HeroSubCardComponentContainer";
import { Gallery } from "./Gallery";
import { Footer } from "./Footer";

const _interactionsData = JSON.parse(
  '{"events":{"e-31":{"id":"e-31","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-32"}},"mediaQueries":["main"],"target":{"selector":".navbar_interaction-trigger","originalId":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"CLASS"},"targets":[{"id":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1702402485163},"e-32":{"id":"e-32","name":"","animationType":"custom","eventTypeId":"SCROLL_OUT_OF_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-16","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-31"}},"mediaQueries":["main"],"target":{"selector":".navbar_interaction-trigger","originalId":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"CLASS"},"targets":[{"id":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1702402485163},"e-43":{"id":"e-43","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-44"}},"mediaQueries":["main"],"target":{"id":"cccde99a-73a6-e896-6acf-3e9706953696","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"cccde99a-73a6-e896-6acf-3e9706953696","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1702674884453},"e-44":{"id":"e-44","name":"","animationType":"preset","eventTypeId":"SCROLL_OUT_OF_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-16","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-43"}},"mediaQueries":["main"],"target":{"id":"cccde99a-73a6-e896-6acf-3e9706953696","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"cccde99a-73a6-e896-6acf-3e9706953696","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1702674884453}},"actionLists":{"a-15":{"id":"a-15","title":"Navbar [transparent]","actionItemGroups":[{"actionItems":[{"id":"a-15-n","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]},{"actionItems":[{"id":"a-15-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]}],"useFirstGroupAsInitialState":true,"createdOn":1702402503174},"a-16":{"id":"a-16","title":"Navbar [solid]","actionItemGroups":[{"actionItems":[{"id":"a-16-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":1}}]}],"useFirstGroupAsInitialState":false,"createdOn":1702402503174}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function PageComponentContactUs({
  as: _Component = _Builtin.Block,
  formSlot,
}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <_Component tag="div">
      <GlobalStyles />
      <_Builtin.Block className="page-wrapper" tag="div">
        <_Builtin.Block
          className="navbar_interaction-trigger"
          data-w-id="cccde99a-73a6-e896-6acf-3e9706953696"
          tag="div"
        />
        <Navbar />
        <_Builtin.Block className="main-wrapper" tag="main">
          <_Builtin.Block className="header" tag="header">
            <_Builtin.Block className="padding-global" tag="div">
              <_Builtin.Block className="container-small" tag="div">
                <_Builtin.Block className="header30_content" tag="div">
                  <_Builtin.Block className="padding-section-large" tag="div">
                    <_Builtin.Block className="text-align-center" tag="div">
                      <_Builtin.Heading className="text-color-white" tag="h1">
                        {"Contact Us"}
                      </_Builtin.Heading>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className="header30_background-image-wrapper"
              tag="div"
            >
              <_Builtin.Block className="image-overlay-layer" tag="div" />
              <_Builtin.Image
                className="header30_background-image"
                loading="eager"
                width="auto"
                height="auto"
                fetchPriority="high"
                alt=""
                src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/6601a65145c11a15982b4357_lifestyle-sofa%20(1).jpg"
              />
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block className="map" tag="section">
            <_Builtin.Block className="padding-global" tag="div">
              <_Builtin.Block className="container-large" tag="div">
                <_Builtin.Block className="padding-section-large" tag="div">
                  <_Builtin.Grid className="header2_component" tag="div">
                    <_Builtin.Block
                      className="header2_content-contract"
                      tag="div"
                    >
                      <_Builtin.Block
                        className="margin-bottom margin-small"
                        tag="div"
                      >
                        <_Builtin.Heading tag="h2">
                          {"WE’RE HERE "}
                          <_Builtin.Span className="text-color-blue">
                            {"TO HELP"}
                          </_Builtin.Span>
                        </_Builtin.Heading>
                      </_Builtin.Block>
                      <_Builtin.HtmlEmbed value="%3Cp%20class%3D%22max-width-medium%22%3EYou%20can%20count%20on%20us%20to%20be%20readily%20available%2C%20address%20inquiries%2C%20and%20make%20sure%20your%20home%20remains%20a%20source%20of%20comfort%20and%20happiness.%3Cbr%3E%E2%80%8D%3Cbr%3EIf%20you%20are%20a%20current%20resident%2C%20additional%20help%20is%20available%20by%20contacting%20your%20community%20manager%20through%20your%20%3Ca%20href%3D%22%2Fresidents%22%20class%3D%22link-class%22%3EResident%20Portal%3C%2Fa%3E.%20%3Cstrong%3EPlease%20no%20solicitations.%3C%2Fstrong%3E%3C%2Fp%3E" />
                    </_Builtin.Block>
                    <_Builtin.Block tag="div">
                      {formSlot ?? (
                        <ContactFormContactUsPage
                          formRuntimeProps={{}}
                          communitySelectRuntimeProp={{}}
                        />
                      )}
                    </_Builtin.Block>
                  </_Builtin.Grid>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block className="current-residents" tag="section">
            <_Builtin.Block className="padding-global" tag="div">
              <_Builtin.Block className="container-large" tag="div" />
            </_Builtin.Block>
          </_Builtin.Block>
          <HeroSubCardComponentContainer />
          <_Builtin.Block
            className="difference_component background-color-grey"
            tag="section"
          >
            <_Builtin.Block className="padding-global mobile-none" tag="div">
              <_Builtin.Block className="container-large" tag="div">
                <_Builtin.Block tag="div">
                  <_Builtin.Block className="mobile-padding-global" tag="div">
                    <_Builtin.Block className="communities_header" tag="div">
                      <_Builtin.Block
                        className="difference_heading-wrapper"
                        tag="div"
                      >
                        <_Builtin.Heading tag="h2">
                          {"THE SRG "}
                          <_Builtin.Span className="text-color-blue">
                            {"Difference"}
                          </_Builtin.Span>
                        </_Builtin.Heading>
                      </_Builtin.Block>
                      <_Builtin.Block
                        className="decoration-line is-black"
                        tag="wrapper"
                      />
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block className="div-block-34" tag="div">
                    <_Builtin.Block className="mobile-padding-global" tag="div">
                      <_Builtin.Block className="max-width-medium" tag="div">
                        <_Builtin.Paragraph className="text-size-medium">
                          {
                            "At SRG Residential, we take utmost pride in being a reliable support system for our residents and employees, fostering strong and vibrant communities where everyone feels valued and cared for. We understand the importance of loving where you live and that's why we are committed to providing hassle-free living experiences."
                          }
                        </_Builtin.Paragraph>
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className="stats-background is-grey"
                      tag="div"
                    >
                      <_Builtin.Block tag="div">
                        <_Builtin.Block
                          className="heading-style-h6 text-color-black"
                          tag="div"
                        >
                          {"Locations"}
                        </_Builtin.Block>
                        <_Builtin.Block
                          className="heading-style-h1 text-color-blue"
                          tag="div"
                        >
                          {"150+"}
                        </_Builtin.Block>
                      </_Builtin.Block>
                      <_Builtin.Block tag="div">
                        <_Builtin.Block
                          className="heading-style-h6 text-color-black"
                          tag="div"
                        >
                          {"Founded"}
                        </_Builtin.Block>
                        <_Builtin.Block
                          className="heading-style-h1 text-color-blue"
                          tag="div"
                        >
                          {"1993"}
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <Gallery />
        </_Builtin.Block>
        <Footer />
      </_Builtin.Block>
    </_Component>
  );
}
